const state = {
  isLoggedIn: false,
  token: '',
  refreshToken: '',
  completed: false
}

const mutations = {
  'AUTH_STATUS_CHANGE' (state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn
  },
  'SET_USER_TOKEN' (state, token) {
    state.token = token
  },
  'SET_USER_REFRESHTOKEN' (state, refreshToken) {
    state.refreshToken = refreshToken
  },
  'SET_USER_COMPLETE' (state, isCompleted) {
    state.completed = isCompleted
  },
}

const actions = {
  logout ({ commit }) {
    commit('AUTH_STATUS_CHANGE', false)
    commit('SET_USER_TOKEN', '')
    commit('SET_USER_REFRESHTOKEN', '')
    commit('SET_USER_COMPLETE', false)
    localStorage.removeItem('onboarding_tours')
    localStorage.removeItem('onboarding_user_created_at')
  },
  login ({ commit }, {token, tokenRefresh}) {
    commit('AUTH_STATUS_CHANGE', true)
    commit('SET_USER_TOKEN', token)
    commit('SET_USER_REFRESHTOKEN', tokenRefresh)
  },
  refreshToken ({commit}, token) {
    commit('SET_USER_TOKEN', token)
  },
  profileComplete ({commit}, isCompleted) {
    commit('SET_USER_COMPLETE', isCompleted)
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}